(function () {
  'use strict';

  const button = document.querySelector('[data-zzai-scroll-top]');
  if (!button) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const threshold = 520;
  let ticking = false;

  function setVisible(isVisible) {
    button.hidden = !isVisible;
    button.classList.toggle('is-visible', isVisible);
  }

  function update() {
    ticking = false;
    setVisible(window.scrollY > threshold);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
    });
  });

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  update();
})();
